import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fi-sr-gears",
  "use": "icon-fi-sr-gears-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-fi-sr-gears\"><path d=\"M10.37,10.67l1.95,1.12,1.5-2.6-1.94-1.12c.08-.35,.12-.71,.12-1.08s-.05-.73-.12-1.08l1.94-1.12-1.5-2.6-1.95,1.12c-.53-.49-1.17-.85-1.87-1.07V0h-3V2.26c-.7,.22-1.34,.59-1.87,1.07l-1.95-1.12L.19,4.81l1.94,1.12c-.08,.35-.12,.71-.12,1.08s.05,.73,.12,1.08L.19,9.19l1.5,2.6,1.95-1.12c.53,.49,1.17,.85,1.87,1.07v2.26h3v-2.26c.7-.22,1.34-.59,1.87-1.07Zm-3.37-5.67c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2Zm15,12c0-.37-.05-.73-.12-1.08l1.94-1.12-1.5-2.6-1.95,1.12c-.53-.49-1.17-.85-1.87-1.07v-2.26h-3v2.26c-.7,.22-1.34,.59-1.87,1.07l-1.95-1.12-1.5,2.6,1.94,1.12c-.08,.35-.12,.71-.12,1.08s.05,.73,.12,1.08l-1.94,1.12,1.5,2.6,1.95-1.12c.53,.49,1.17,.85,1.87,1.07v2.26h3v-2.26c.7-.22,1.34-.59,1.87-1.07l1.95,1.12,1.5-2.6-1.94-1.12c.08-.35,.12-.71,.12-1.08Zm-5,2c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fi-sr-gears.svg
// module id = rBLO
// module chunks = 63